import type { ExtractThemeOverrides, Theme } from '../../_mixins'
import type { ThemeCommonVars } from '../../_styles/common'
import type { ButtonTheme } from '../../button/styles'
import { createTheme } from '../../_mixins'
import { commonLight } from '../../_styles/common'
import { buttonLight } from '../../button/styles'
import commonVars from './_common'

export function self(vars: ThemeCommonVars) {
  const {
    textColor1,
    textColor2,
    modalColor,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeColorHover,
    closeColorPressed,
    infoColor,
    successColor,
    warningColor,
    errorColor,
    primaryColor,
    dividerColor,
    borderRadius,
    fontWeightStrong,
    lineHeight,
    fontSize
  } = vars
  return {
    ...commonVars,
    fontSize,
    lineHeight,
    border: `1px solid ${dividerColor}`,
    titleTextColor: textColor1,
    textColor: textColor2,
    color: modalColor,
    closeColorHover,
    closeColorPressed,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeBorderRadius: borderRadius,
    iconColor: primaryColor,
    iconColorInfo: infoColor,
    iconColorSuccess: successColor,
    iconColorWarning: warningColor,
    iconColorError: errorColor,
    borderRadius,
    titleFontWeight: fontWeightStrong
  }
}

export interface DialogThemeVars extends ReturnType<typeof self> {}

const dialogLight: DialogTheme = createTheme({
  name: 'Dialog',
  common: commonLight,
  peers: {
    Button: buttonLight
  },
  self
})

export interface DialogTheme extends Theme<
  'Dialog',
  DialogThemeVars,
  {
    Button: ButtonTheme
  }
> {}

export interface DialogThemeOverrides extends ExtractThemeOverrides<DialogTheme> {}

export default dialogLight
